export default __webpack_public_path__ + "static/media/nis_s.6d2b5ffe.jpg";